var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',{attrs:{"value":_vm.value,"items":_setup.pricingStatusOptions,"label":"Pricing status","menu-props":{
    bottom: true,
    offsetY: true,
    contentClass: 'mt-1'
  },"dense":"","outlined":"","hide-details":""},on:{"input":function($event){return _setup.emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }